module.exports = __webpack_public_path__ + "img/new-chat-icon.e40c809f.svg";